import { Events } from "@Context/common/general/context";
import { useApi } from "@hooks";
import useGlobalContext from "@hooks/common/general/use-global-context";
import { Api } from "@Shared/schemas";
import { GetAccountResponse } from "@Shared/schemas/accounts/accountSchemas";
import { createContext, ReactNode, useContext, useEffect, useState } from "react";

interface AccountSelectionContextType {
    accounts: GetAccountResponse[];
    loading: boolean;
    handleAccountSelect: (accountId: number) => void;
}

const AccountSelectionContext = createContext<AccountSelectionContextType | undefined>(undefined);

interface AccountSelectionProviderProps {
    children: ReactNode;
}

export const AccountSelectionProvider = ({ children }: AccountSelectionProviderProps) => {
    const { globalState } = useGlobalContext();
    const [accounts, setAccounts] = useState<GetAccountResponse[]>([]);


    const { call: getAccounts, loading } = useApi<typeof Api.Account.GetAccounts>({
        api: Api.Account.GetAccounts,
        request: {
            resolve_members: true
        },
        onSuccess: (response) => {
            if (response.data) {
                const sortedAccounts = response.data?.sort((a, b) => 
                    (a.name > b.name ? 1 : -1)
                );
                setAccounts(sortedAccounts);
            }
        }
    });

    const handleAccountSelect = (accountId: number) => {
        Events.account.switchAccount.emit({ account_id: accountId });
    };

    useEffect(() => {
        getAccounts();
    }, []);

    const value = {
        accounts,
        loading,
        handleAccountSelect,
    };

    return <AccountSelectionContext.Provider value={value}>{children}</AccountSelectionContext.Provider>;
};

export const useAccountSelection = () => {
    const context = useContext(AccountSelectionContext);
    if (context === undefined) {
        throw new Error("useAccountSelection must be used within a AccountSelectionProvider");
    }
    return context;
}; 